import Refresh from "@mui/icons-material/Refresh";
import { IconButton } from "@mui/material";

export interface RefreshButtonProps {
  invalidateQueries: Function
  onClick?: () => void
}

export const RefreshButton = (props: RefreshButtonProps) => {
  return (
    <IconButton
      style={{ cursor: "pointer" }}
      onClick={() => {
        if (props.onClick) {
          props.onClick()
        } else {
          props.invalidateQueries()
        }
      }}>
      <Refresh />
    </IconButton>
  );
}